import axios from 'axios'
import JwtService from "../services/jwt-service";
import router from "../router";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

const handleRequestInterceptor = (config) => {
  const token = JwtService.getToken()

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  return config
}

const handleSuccessResponseInterceptor = response => response.data

const handleErrorResponseInterceptor = (error) => {
  const statusCode = error?.response?.status


  if (statusCode === 401) {
    if (typeof error.response?.data === 'string') {
      JwtService.destroyToken()
      router.push({ name: 'sign-in' })
    }
  }

  return Promise.reject(error.response?.data)
}

axiosInstance.interceptors.request.use(handleRequestInterceptor)
axiosInstance.interceptors.response.use(handleSuccessResponseInterceptor, handleErrorResponseInterceptor)

export default axiosInstance
